import { render, staticRenderFns } from "./ImportIndex.vue?vue&type=template&id=73d8b8bc&scoped=true&"
import script from "./ImportIndex.vue?vue&type=script&lang=js&"
export * from "./ImportIndex.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/flexben.css?vue&type=style&index=0&id=73d8b8bc&scoped=true&lang=css&"
import style1 from "@/assets/styles/beneficiary.css?vue&type=style&index=1&id=73d8b8bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d8b8bc",
  null
  
)

export default component.exports